import { createAsyncThunk } from '@reduxjs/toolkit';
import baseURL from '../utils/baseURL';
import useAxiosAuth from '../hooks/useAxiosAuth';

// One assistant turn. Identity is derived from the JWT on the backend — the
// widget only sends the text and a session id. Returns { reply, session_id }.
export const sendAssistantMessage = createAsyncThunk(
    'assistant/sendMessage',
    async ({ message, sessionId, surface = 'widget' }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(`${baseURL}/assistant/chat`, { message, sessionId, surface });
            return response.data?.data || null;
        } catch (error) {
            return rejectWithValue(error?.response?.data || { message: 'Assistant unavailable' });
        }
    }
);

// Mic clip → text (backend proxies to the AI's Whisper STT). Returns { text }.
export const sendAssistantVoice = createAsyncThunk(
    'assistant/sendVoice',
    async ({ blob }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const form = new FormData();
            form.append('audio', blob, 'voice.webm');
            const response = await axiosInstance.post(`${baseURL}/assistant/voice`, form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data?.data || null;
        } catch (error) {
            return rejectWithValue(error?.response?.data || { message: 'Transcription failed' });
        }
    }
);
